import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from 'axios';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
import Grid from "@material-ui/core/Grid";
import CloseIcon from "../icons/CloseIcon";
import AddedIcon from "../icons/AddedIcon";
import Typography from "@material-ui/core/Typography";
import CardActionArea from '@material-ui/core/CardActionArea';
import Paper from '@material-ui/core/Paper';
import LinearProgress from "@material-ui/core/LinearProgress";
import CustomInput from './CustomInput';
import DropZone from './dropzone/DropZone';
import translate from '../other/translate.json';
import config from '../other/config';
import AddCompleteSetIcon from './../icons/AddCompleteSetIcon';
import utils from "../other/utils";
import DoneIcon from './../icons/DoneIcon';
const { serverAPI } = config;
const { hasProperty } = utils;

export default function WriteToUs(props) {
  let lang = localStorage.getItem('language') || 'Ru'
  const classes = useStyles();
  const {isAuth, usname} = props;
  // const [state, setState] = React.useState(false);
  const [authFio, _authFio] = useState(props.usname?.usname);
  const [authBank, _authBank] = useState(props.usname?.organization);
  const [authMobile, _authMobile] = useState(props.usname?.phone);
  const [authMail, _authMail] = useState(props.usname?.email);
  const [fio, setFio] = useState('');
  const [bank, setBank] = useState('');
  const [position, setPosition] = useState('');
  const [mobile, setMobile] = useState('');
  const [mail, setMail] = useState('');
  const [letter, setLetter] = useState('');
  const [answer, setAnswer] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const fileInputRef = useRef();
  const [unsupportedFiles, setUnsupportedFiles] = useState([]);
  const [validFiles, setValidFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isReading, setIsReading] = useState(false);
  const [attachments, _attachments] = useState([]);

  let MIN = 0;
  let MAX = 4;
  let value = 3;


  useEffect(() => {
    // if (props.isAuth == true) {
    let didCancel = false;
    async function fetchData() {
      const login = usname//await axios.get(`${serverAPI}/auth`);
      if (!didCancel && isAuth ) {
        console.log("wtu-auth",login)
        if (login && login) {
          _authFio(login.usname);
          _authBank(login.organization);
          _authMobile(login.phone);
          _authMail(login.email);
          setFio(login.usname)
          setBank(login.organization)
          setPosition(login.title)
          setMobile(login.phone)
          setMail(login.email)
        }
      }
    }

    fetchData();

    return () => {
      didCancel = true;
    };
    // }
  }, [isAuth]);

  useEffect(() => {
    let filteredArray = selectedFiles.reduce((file, current) => {
      const x = file.find(item => item.name === current.name);
      if (!x) {
        return file.concat([current]);
      } else {
        return file;
      }
    }, []);
    setValidFiles([...filteredArray]);

  }, [selectedFiles]);

  let { stateAsk, setStateAsk } = props

  function toggleDrawer(open, event) {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    // setState(open);
  };

  function closeDrawer() {
    setStateAsk(false)
    setAnswer('')
    _attachments([])
  }

  function cutFioValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setFio(value.replace(/ +/g, ' '))
  }

  function cutMailValue(value) {
    const shouldSetValue = value.length < 255

    if (shouldSetValue) setMail(value.replace(/ +/g, ' '))
  }

  function cutBankValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setBank(value.replace(/ +/g, ' '))
  }

  function cutMobileValue(value) {
    const shouldSetValue = value.length < 51

    if (shouldSetValue) setMobile(value.replace(/ +/g, ' '))
  }

  function cutLetterValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setLetter(value.replace(/ +/g, ' '))
  }

  function fileInputClicked() {
    if (errorMessage) {
      removeFile()
      setErrorMessage('');
    }
    fileInputRef.current.click();
  }

  function dragOver(e) {
    e.preventDefault();
  }

  function dragEnter(e) {
    e.preventDefault();
  }

  function dragLeave(e) {
    e.preventDefault();
  }

  function fileDrop(e) {
    setUnsupportedFiles([])
    setErrorMessage('');
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFiles(files);
    }
  }

  function removeFile() {
    setValidFiles([]);
    setSelectedFiles([]);
    setUnsupportedFiles([]);
    fileInputRef.current.value = ""
  }

  function handleFiles(file) {
    // console.log('file', file);
    for (let i = 0; i < file.length; i++) {
      if (validateFile(file[i])) {
        // add to an array so we can display the name of file
        // setIsReading(true);
        // readFile(file[0])
        setSelectedFiles(prevArray => [file[i]]);
      } else {
        // add a new property called invalid
        file[i]['invalid'] = true;
        // add to the same array so we can display the name of the file
        setSelectedFiles(prevArray => [file[i]]);
        // set error message
        setErrorMessage(translate.Words[`Uploaded${lang}`]);
        setUnsupportedFiles(prevArray => [file[i]]);
      }
    }
  }

  function validateFile(file) {
    if (file.size > 10000000) {
      return false;
    }
    return true;
  }

  function filesSelected() {
    if (fileInputRef.current.files.length) {
      // console.log('fileInputRef', fileInputRef);
      setUnsupportedFiles([]);
      handleFiles(fileInputRef.current.files);
    }
  }

  function uploadFiles() {
    for (let i = 0; i < validFiles.length; i++) {
      setIsReading(true);
      handleFileChange(validFiles[i])
    }
  }

  const handleFileChange = useCallback((e) => {
    let ids = [], products = [], services = [];
    let response = [];
    const file = e;
    var reader = new FileReader();
    reader.onload = async function (e) {
      var data = new FormData();
      data.append('file', file);

      await axios.post(`${serverAPI}/attch_uploader`, data, {}).then(res => {
        // console.log('handleFileChange - res', res)
        setIsReading(false);
        if (res.data.result === 'OK') {
          // Обработка ответа от БД
          _attachments(attachments.concat(res.data.filename))

        } else {
          setErrorMessage(translate.Words[`UploadedErr${lang}`]);
        }
      })
    };
    reader.readAsArrayBuffer(file);
  }, []);

  const BorderLinearProgress = withStyles((theme) => ({
    root: {
      height: 2,
      borderRadius: 20
    },
    colorPrimary: {
      backgroundColor: "#BCBBD0"
    },
    bar: {
      borderRadius: 5,
      backgroundColor: "#81D39D"
    }
  }))(LinearProgress);

  async function sendmail() {
    let body = 'body_'
    let sender = fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? fio.trim() : '';
    let senderbank = bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? bank.trim() : ''
    let senderposition = position.trim()
    let senderphone = mobile.trim()
    let sendermail = mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? mail.trim() : '';
    let receivers = '';
    let subject = 'Написать Нам';
    // let attachments = [];

    if (sender !== '' && senderbank !== '' && sendermail !== '') {
      const sendmail_res = await axios.post(`${serverAPI}/send_mail_with_attchments`,
        { letter, receivers: sendermail, subject, attchments: attachments, sender, senderbank, senderposition, senderphone, link: window.location.href }
        // { body, sender, senderbank, senderposition, senderphone, sendermail, letter, 'link': props.link ? props.link : `${serverAPI}/export2/complectation?applications=${appBasketNew}&products=${prodBasketNew}&clouds=${cloudBasket}` }
      )
      // closeDrawer()
      setAnswer(sendmail_res.data.result)
    }
  }

  function list(anchor) {
    return (
      <div
        className={classes.list}
        role="presentation"
        onClick={() => toggleDrawer(anchor, false)}
        onKeyDown={() => toggleDrawer(anchor, false)}
        style={{ overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin' }}
      >
        <Grid
          container
          direction="column"
          justify="flex-start"
          className={classes.root}
        >
          <Grid item container>
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item style={{ marginTop: 14 }}>
              <Typography className={classes.listHeader}>{translate.Discuss[`WriteToUs_${lang}`]}    </Typography>
            </Grid>
          </Grid>

          <Grid item container direction="column" style={{ marginTop: 29 }}>
            <Grid item>
              <form className={classes.rootForm} noValidate>
                <Grid container direction="column">
                  <Grid item>
                    <CustomInput
                      disabled={authFio?.length > 1}
                      error={fio.trim() === '' || fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? false : true}
                      valid={fio.trim() !== '' && fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? true : false}
                      helperText={fio === '' ? translate.Discuss[`MandatoryField${lang}`] : fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectData${lang}`]}
                      value={fio}
                      onChange={(e) => cutFioValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`LetterFullNamen_${lang}`]}
                      hint
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authMail?.length > 1}
                      error={mail.trim() === '' || mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? false : true}
                      valid={mail.trim() !== '' && mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? true : false}
                      helperText={mail === '' ? translate.Discuss[`MandatoryField${lang}`] : mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectEmail${lang}`]}
                      value={mail}
                      onChange={(e) => cutMailValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Email${lang}`]}
                      hint
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authBank?.length > 1}
                      error={bank.trim() === '' || bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? false : true}
                      valid={bank.trim() !== '' && bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? true : false}
                      helperText={bank === '' ? translate.Discuss[`MandatoryField${lang}`] : bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectData${lang}`]}
                      value={bank}
                      onChange={(e) => cutBankValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Company${lang}`]}
                      hint
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authMobile?.length > 1}
                      value={mobile}
                      onChange={(e) => cutMobileValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`ContactPhone${lang}`]}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      value={letter}
                      onChange={(e) => cutLetterValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`TypeYourTextHere${lang}`]}
                      multiline={true}
                    />
                  </Grid>

                  <Grid item container direction="column" justify="flex-start" alignItems="flex-start">
                    <CardActionArea onClick={fileInputClicked} style={{ borderRadius: '16px', zIndex: 55, margin: '12px 0' }}>
                      <Grid container className={classes.dropContainer} onDragOver={(e) => dragOver(e)} onDragEnter={(e) => dragEnter(e)} onDragLeave={(e) => dragLeave(e)} onDrop={(e) => fileDrop(e)}>
                        <Grid container style={{ padding: '32px 20px 0 20px', cursor: 'pointer' }}>
                          <Grid item container direction="column" justify="flex-start" alignItems="center" className={classes.DropMessage}>
                            <input
                              ref={fileInputRef}
                              className={classes.FileInput}
                              type="file"
                              accept="image/jpeg, image/png"
                              onChange={filesSelected}
                            />

                            <Grid item container>
                              <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                                style={{ width: '100%', padding: '0px 0 0px 16px' }}
                              >
                                <Grid item container direction="row" style={{ width: "100%" }}>
                                  <Grid item>
                                    <AddCompleteSetIcon fill={'#BCBBD0'} />
                                  </Grid>

                                  <Grid item style={{ marginLeft: 8 }}>
                                    {
                                      lang === 'Ru'
                                        ?
                                        <Typography component='p' className={classes.DesktopBody1} style={{ lineHeight: '45px' }}>Прикрепить вложение</Typography>
                                        :
                                        <Typography component='p' className={classes.DesktopBody1} style={{ lineHeight: '45px' }}>Attach attachment</Typography>
                                    }
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item container>
                            {
                              validFiles.map((data, i) =>
                                <React.Fragment>
                                  {!(data.invalid || errorMessage) && isReading === false ?
                                    <Paper className={classes.FileStatusBar} key={i} onClick={(e) => e.stopPropagation()} style={{ marginTop: 24, padding: '24px 16px', boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)' }}>
                                      <Grid
                                        item
                                        container
                                        direction="row"
                                        justify="space-between"
                                        alignItems="center"
                                      >
                                        <div><DoneIcon /></div>
                                        <span className={classes.FileName} style={{ color: '#24262A', wordBreak: 'break-word' }}>{data.name}</span>
                                        <div className={classes.FileRemove} onClick={() => removeFile(data.name)}><CloseIcon fill={'#8987A2'} /></div>
                                      </Grid>
                                    </Paper>
                                    :
                                    data.invalid || errorMessage ?
                                      (data.invalid || errorMessage) && <Grid container direction="column" justify="flex-start" alignItems="center" style={{ marginTop: 24 }}><Grid item style={{ maxWidth: 272, textAlign: 'center' }}><span className={classes.FileErrorMessage}>{errorMessage}</span></Grid></Grid>
                                      :
                                      isReading === true ?
                                        <Grid container
                                          direction="column"
                                          justify="flex-start"
                                          alignItems="center" style={{ marginTop: 24, marginBottom: 20, height: 72 }}
                                        >
                                          <Grid item container style={{ width: '100%', height: 42 }}>
                                            <Grid item className={classes.progress} style={{ width: '100%' }}>
                                              <BorderLinearProgress
                                                variant="determinate"
                                                value={((value - MIN) * 100) / (MAX - MIN)}
                                              />
                                            </Grid>

                                            <Typography component='p' className={classes.DesktopBody1} style={{ marginTop: 16, textAlign: 'center', width: '100%' }}>
                                              {translate.Words[`Loading${lang}`]}...</Typography>
                                          </Grid>
                                        </Grid>
                                        :
                                        ''
                                  }
                                </React.Fragment>
                              )
                            }
                          </Grid>
                        </Grid>

                        <Grid item container direction='row' style={{ padding: '4px 0 32px', maxWidth: 376, maxHeight: 91 }}>
                          {unsupportedFiles.length === 0 && validFiles.length && !errorMessage && attachments.length === 0 ?
                            <Grid item container direction="row" justify="space-between" alignItems="center" onClick={(e) => e.stopPropagation()} style={{ zIndex: 88 }}>
                              <SecondaryButton height={55} text={translate.Words[`Cancel${lang}`]} onClick={() => removeFile()} />

                              <PrimaryButton height={55} text={translate.Words[`Attach${lang}`]} onClick={() => uploadFiles()} />
                            </Grid>
                            : ''}
                        </Grid>
                      </Grid>
                    </CardActionArea>
                  </Grid >
                </Grid>
              </form>
            </Grid>

            <Grid item container className={classes.ActionArea}>
              <PrimaryButton
                disabled={
                  (fio.trim() !== '' && fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/))
                    &&
                    (mail.trim() !== '' && mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i))
                    &&
                    (bank.trim() !== '' && bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/))
                    &&
                    (letter.trim() !== '' && letter.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/))
                    && errorMessage !== translate.Words[`UploadedErr${lang}`]
                    ?
                    false
                    :
                    true
                }
                height={55}
                text={translate.Discuss[`Send_${lang}`]}
                onClick={() => sendmail()}
              />
            </Grid>

            <Grid item style={{ marginTop: 24 }}>

            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  };

  function listSubmitTrue() {
    return (
      <div
        className={classes.list}
        role="presentation"
      >
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.root}
          style={{ padding: 64, paddingTop: 254 }}
        >
          <Grid item container direction="column" justify="center" alignItems="center">
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ width: 72, height: 72, backgroundColor: '#81D39D', borderRadius: '50%', boxShadow: 'none' }}
              >
                <AddedIcon fill={'#FFFFFF'} />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>{translate.Discuss[`YouRequest${lang}`]}</Typography>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>{translate.Discuss[`Successfully${lang}`]}</Typography>
            </Grid>

            <Grid item style={{ marginTop: 40 }}>
              <PrimaryButton onClick={() => closeDrawer()} height={55} text={'Закрыть'} />
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  };

  function listSubmitFalse() {
    return (
      <div
        className={classes.list}
        role="presentation"
      >
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.root}
          style={{ padding: 64, paddingTop: 254 }}
        >
          <Grid item container direction="column" justify="center" alignItems="center">
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ width: 72, height: 72, backgroundColor: '#BCBBD0', borderRadius: '50%', boxShadow: 'none' }}
              >
                <CloseIcon fill={'#FFFFFF'} />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>По техническим причинам</Typography>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>сервис временно недоступен.</Typography>
            </Grid>

            <Grid item style={{ marginTop: 24 }}>
              <Typography className={classes.Body1}>Попробуйте повторно позднее.</Typography>
            </Grid>

            <Grid item style={{ marginTop: 40 }}>
              <PrimaryButton onClick={() => closeDrawer()} height={55} text={'Закрыть'} />
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  };

  // console.log((fio.trim() !== '' && fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/))
  //   ,
  //   (mail.trim() !== '' && mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i))
  //   ,
  //   (bank.trim() !== '' && bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/)))

  return (
    <div>
      <React.Fragment key="anchor">
        <Drawer
          anchor={"right"}
          open={stateAsk}
          onClose={() => closeDrawer()}
        >
          <Grid className={classes.btnClose}>
            <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
              <CloseIcon fill='#BCBBD0' />
            </IconButton>
          </Grid>
          {
            props.AskCFT
              ?
              <React.Fragment>
                {
                  answer === 1
                    ?
                    listSubmitTrue('right')
                    :
                    answer === 0
                      ?
                      listSubmitFalse('right')
                      :
                      list()
                }
              </React.Fragment>
              :
              <React.Fragment><DropZone /></React.Fragment>
          }
        </Drawer>
      </React.Fragment>
    </div>
  );

}

const useStyles = makeStyles(theme => ({
  root: {
    padding: 64,

    [theme.breakpoints.down(500)]: {
      padding: 24,
    },
  },

  list: {
    width: 600,

    [theme.breakpoints.down(696)]: {
      width: '100%',
    },
  },

  fullList: {
    width: 'auto',
  },

  listHeader: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '28px',
    lineHeight: '40px',
    color: "#24262A"
  },

  btnClose: {
    position: 'absolute',
    right: 12,
    top: 12,

    [theme.breakpoints.down(500)]: {
      zIndex: 1,
      borderRadius: '50%',
      backgroundColor: '#FFFFFF',
    }
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  },

  Info1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#BCBBD0'
  },

  Caption1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '28px',
    display: 'flex',
    alignItems: 'center',
  },

  LinkType11: {
    color: 'inherit',
    textDecoration: 'none',
    borderBottom: '1px solid',
    borderColor: 'inherit',

    '&:hover': {
      color: '#2050FF',
      textDecoration: 'none',
      borderBottom: '1px solid #2050FF',
    }
  },

  ActionArea: {
    justifyContent: "space-between",
    marginTop: 28,
    maxWidth: 472,
  },

  dropContainer: {
    // display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    maxWidth: 472,
    // height: 521,
    border: '1px dashed #BCBBD0',
    borderRadius: '16px'
  },

  DesktopBody1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
  },

  DropMessage: {
    textAlign: 'center',
    color: '#4aa1f3',
    fontFamily: 'Arial',
    fontSize: '20px',
    width: '100%'
  },

  UploadIcon: {
    width: 36,
    height: 45,
    backgroundSize: '100%',
    textAlign: 'center',
    margin: '0 auto',
  },

  FileStatusBar: {
    width: '100%',
    verticalAlign: 'top',
    marginTop: 10,
    marginBottom: 20,
    position: 'relative',
    lineHeight: '24px',

    '& div': {
      overflow: 'hidden',
    }
  },

  FileName: {
    width: 296,
    color: '#4aa1f3',
  },

  FileError: {
    display: 'inline-block',
    verticalAlign: 'top',
    marginLeft: 50,
    color: '#9aa9bb',
  },

  FileErrorMessage: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#EB505E',
  },

  FileRemove: {
    lineHeight: '15px',
    cursor: 'pointer',
    color: 'red',
  },

  FileInput: {
    display: 'none'
  },

  error: {
    color: 'red',
  },

  progress: {
    flexGrow: 1,
    width: '100%'
  }
}));